module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6pGuf"))).then(() => parcelRequire('hEqeo'));